import React, {useCallback, useState} from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {useCustomerMgr} from 'coreHooks';

import Button from 'brandComponents/Button';
import Typography from 'brandComponents/Typography';

import {IDeleteButtonProps} from './IDeleteButton';
import messages from './messages';

import styles from './DeleteButton.module.scss';

const DeleteButton = ({paymentInstrumentId, classNames, variant = 'secondary'}: IDeleteButtonProps) => {
	const intl = useIntl();
	const [isDeleting, setIsDeleting] = useState(false);
	const CustomerMgr = useCustomerMgr();

	const handleIsDelete = useCallback(() => {
		setIsDeleting((current) => !current);
	}, []);

	const handleDelete = useCallback(async () => {
		await CustomerMgr.removeCustomerSavedPaymentInstrument(paymentInstrumentId);

		handleIsDelete();
	}, [paymentInstrumentId]);

	return (
		<div className={cn('button-delete-container', styles['button-delete-container'], classNames)}>
			{!isDeleting ? (
				<Button
					variant={variant} onClick={handleIsDelete}
					classNames={cn('button-delete-confirm', styles['button-delete-container'])}
				>
					{intl.formatMessage(messages.deleteMessage)}
				</Button>
			) : (
				<>
					<Typography
						variant="span"
						classNames={cn('button-delete-confirm', styles['button-delete-confirm'])}
					>
						{intl.formatMessage(messages.deleteConfirmMessage)}
					</Typography>
					<Button
						variant={variant}
						onClick={handleDelete}
						classNames={cn('button-delete-submit', styles['button-delete-submit'])}
					>
						{intl.formatMessage(messages.submitMessage)}
					</Button>
					<Button
						variant={variant}
						onClick={handleIsDelete}
						classNames={cn('button-delete-discard', styles['button-delete-discard'])}
					>
						{intl.formatMessage(messages.discardMessage)}
					</Button>
				</>
			)}
		</div>
	);
};
export default DeleteButton;
